import type { PersonalPageFamily, PersonalPageSubtype } from './types';

export const PERSONAL_PAGE_SUBTYPE_VALUES = [
  'openDonation',
  'annualCampaign',
  'partnershipCampaign',
  'focusedDonation',
  'choiceDonation',
  'ticketSales',
  'freeEventRegistration',
  'choiceEvent',
  'serviceRegistration',
  'leads',
  'fixedFormLead'
] as const;

export const PERSONAL_PAGE_SUBTYPES_BY_FAMILY: Record<PersonalPageFamily, PersonalPageSubtype[]> = {
  campaign: ['openDonation', 'annualCampaign', 'partnershipCampaign', 'focusedDonation', 'choiceDonation'],
  event: ['ticketSales', 'freeEventRegistration', 'choiceEvent'],
  information: ['serviceRegistration', 'leads', 'fixedFormLead']
};
